import { Intent, Role, Product, Level } from "common/learnerPreferences";
import { getAssetsUrl } from "common/helpers";

import commerceImg from "../../common/assets/commerce.svg";
import dataImg from "../../common/assets/data.svg";
import einsteinImg from "../../common/assets/einstein.svg";
import financialImg from "../../common/assets/financial.svg";
import marketingImg from "../../common/assets/marketing.svg";
import mulesoftImg from "../../common/assets/mulesoft.svg";
import nonprofitImg from "../../common/assets/nonprofit.svg";
import platformImg from "../../common/assets/platform.svg";
import salesImg from "../../common/assets/sales.svg";
import serviceImg from "../../common/assets/service.svg";
import slackImg from "../../common/assets/slack.svg";
import herokuImg from "../../common/assets/heroku.svg";
import tableauImg from "../../common/assets/tableau.svg";
import analyticsImg from "../../common/assets/analytics.svg";
import healthImg from "../../common/assets/health.svg";
import educationImg from "../../common/assets/education.svg";
import manufacturingImg from "../../common/assets/manufacturing.svg";
import consumerImg from "../../common/assets/consumer.svg";
import publicImg from "../../common/assets/public.svg";
import loyaltyImg from "../../common/assets/loyalty.svg";
import experienceImg from "../../common/assets/experience.svg";
import netzeroImg from "../../common/assets/netzero.svg";
import appexchangeImg from "../../common/assets/appexchange.svg";
import agentforceImg from "../../common/assets/agentforce.svg";

import advancedImg from "../../common/assets/advanced.svg";
import beginnerImg from "../../common/assets/beginner.svg";
import intermediateImg from "../../common/assets/intermediate.svg";

export const getIntents = (): Array<unknown> => [
  {
    id: Intent.Exploring,
    title: "explore_title",
    description: "explore_description",
    selected: false,
  },
  {
    id: Intent.NewUser,
    title: "new_title",
    description: "new_description",
    selected: false,
  },
  {
    id: Intent.NewSkills,
    title: "learn_title",
    description: "learn_description",
    selected: false,
  },
  {
    id: Intent.Certification,
    title: "earn_title",
    description: "earn_description",
    selected: false,
  },
  {
    id: Intent.GetHelp,
    title: "help_title",
    description: "help_description",
    selected: false,
  },
  {
    id: Intent.GrowBusiness,
    title: "grow_title",
    description: "grow_description",
    selected: false,
  },
];

export const getRoles = (): Array<unknown> => [
  {
    id: Role.Admin,
    title: "admin",
    selected: false,
  },
  {
    id: Role.Architect,
    title: "architect",
    selected: false,
  },
  {
    id: Role.Developer,
    title: "developer",
    selected: false,
  },
  {
    id: Role.Sales,
    title: "sales",
    selected: false,
  },
  {
    id: Role.Marketer,
    title: "marketer",
    selected: false,
  },
  {
    id: Role.CustomerService,
    title: "customer_service",
    selected: false,
  },
  {
    id: Role.Consultant,
    title: "consultant",
    selected: false,
  },
  {
    id: Role.Designer,
    title: "designer",
    selected: false,
  },
  {
    id: Role.BusinessAnalyst,
    title: "business_analyst",
    selected: false,
  },
  {
    id: Role.Cybersecurity,
    title: "cybersecurity",
    selected: false,
  },
  {
    id: Role.EndUser,
    title: "enduser",
    selected: false,
  },
];

export const getProducts = (): Array<unknown> => [
  {
    id: Product.Agentforce,
    title: "agentforce",
    icon: getAssetsUrl(agentforceImg),
    selected: false,
  },
  {
    id: Product.Einstein,
    title: "einstein",
    icon: getAssetsUrl(einsteinImg),
    selected: false,
  },
  {
    id: Product.DataCloud,
    title: "data",
    icon: getAssetsUrl(dataImg),
    selected: false,
  },
  {
    id: Product.SalesCloud,
    title: "sales",
    icon: getAssetsUrl(salesImg),
    selected: false,
  },
  {
    id: Product.MarketingCloud,
    title: "marketing",
    icon: getAssetsUrl(marketingImg),
    selected: false,
  },
  {
    id: Product.ServiceCloud,
    title: "service",
    icon: getAssetsUrl(serviceImg),
    selected: false,
  },
  {
    id: Product.CommerceCloud,
    title: "commerce",
    icon: getAssetsUrl(commerceImg),
    selected: false,
  },
  {
    id: Product.SalesforcePlatform,
    title: "platform",
    icon: getAssetsUrl(platformImg),
    selected: false,
  },
  {
    id: Product.Tableau,
    title: "tableau",
    icon: getAssetsUrl(tableauImg),
    selected: false,
  },
  {
    id: Product.MuleSoft,
    title: "mulesoft",
    icon: getAssetsUrl(mulesoftImg),
    selected: false,
  },
  {
    id: Product.Slack,
    title: "slack",
    icon: getAssetsUrl(slackImg),
    selected: false,
  },
  {
    id: Product.Heroku,
    title: "heroku",
    icon: getAssetsUrl(herokuImg),
    selected: false,
  },
  {
    id: Product.CRMAnalytics,
    title: "analytics",
    icon: getAssetsUrl(analyticsImg),
    selected: false,
  },
  {
    id: Product.HealthCloud,
    title: "health",
    icon: getAssetsUrl(healthImg),
    selected: false,
  },
  {
    id: Product.EducationCloud,
    title: "education",
    icon: getAssetsUrl(educationImg),
    selected: false,
  },
  {
    id: Product.FinancialServicesCloud,
    title: "financial",
    icon: getAssetsUrl(financialImg),
    selected: false,
  },
  {
    id: Product.NonprofitCloud,
    title: "nonprofit",
    icon: getAssetsUrl(nonprofitImg),
    selected: false,
  },
  {
    id: Product.ManufacturingCloud,
    title: "manufacturing",
    icon: getAssetsUrl(manufacturingImg),
    selected: false,
  },
  {
    id: Product.ConsumerGoodsCloud,
    title: "consumer",
    icon: getAssetsUrl(consumerImg),
    selected: false,
  },
  {
    id: Product.PublicSectorSolutions,
    title: "public",
    icon: getAssetsUrl(publicImg),
    selected: false,
  },
  {
    id: Product.LoyaltyManagement,
    title: "loyalty",
    icon: getAssetsUrl(loyaltyImg),
    selected: false,
  },
  {
    id: Product.ExperienceCloud,
    title: "experience",
    icon: getAssetsUrl(experienceImg),
    selected: false,
  },
  {
    id: Product.NetZeroCloud,
    title: "netzero",
    icon: getAssetsUrl(netzeroImg),
    selected: false,
  },
  {
    id: Product.AppExchange,
    title: "appexchange",
    icon: getAssetsUrl(appexchangeImg),
    selected: false,
  },
];

export const getLevels = (): Array<unknown> => [
  {
    id: Level.Beginner,
    title: "beginner_title",
    description: "beginner_description",
    selected: false,
    icon: getAssetsUrl(beginnerImg),
  },
  {
    id: Level.Intermediate,
    title: "intermediate_title",
    description: "intermediate_description",
    selected: false,
    icon: getAssetsUrl(intermediateImg),
  },
  {
    id: Level.Advanced,
    title: "advanced_title",
    description: "advanced_description",
    selected: false,
    icon: getAssetsUrl(advancedImg),
  },
];
